import {
  browseParamsVar,
  globalDataVar,
  searchResultsVar,
  selectedDepartureVar,
} from '../../operations/localState/reactiveVariables';
import { buildCommonProductObject, getMarketingAirlineCodesFromFlight } from './common';

const siteSection = 'browseflights';

export const trackView = (trackingParams) => {
  if (window.utag) {
    const globalData = globalDataVar();
    let trackingParamsToSend = trackingParams;
    if (globalData) {
      trackingParamsToSend = {
        ...trackingParams,
        country: globalData.country ? globalData.country.toLowerCase() : '',
        language: globalData.language ? globalData.language.toLowerCase() : '',
        currency: globalData.currency ? globalData.currency.toUpperCase() : '',
      };
    }
    window.utag.view(trackingParamsToSend);
  } else {
    // This is necessary because utag.js script is loaded asynchronously
    setTimeout(() => trackView(trackingParams), 1000);
  }
};

export const trackSearchView = () => {
  trackView({
    pageName: `${siteSection}:search`,
    pageType: `${siteSection}:findaflight`,
    siteSection,
  });
};

export const trackBookFlightsView = () => {
  const airbooking = 'airbooking';
  trackView({
    pageName: `${airbooking}:book a flight home`,
    siteSection: airbooking,
  });
};

export const trackInteraction = (trackLinkParams) => {
  if (window.utag) {
    window.utag.link(trackLinkParams);
  } else {
    // This is necessary because utag.js script is loaded asynchronously
    setTimeout(() => window.utag?.link(trackLinkParams), 1000);
  }
};

export const trackSuccessBrowse = () => {
  trackInteraction({
    eventType: 'interactions',
    interaction: 'browseflightlookup:success',
  });
};
export function sendTrackingParams(trackingParamsToSend, isView = true) {
  if (window.utag) {
    if (isView) {
      window.utag.view(trackingParamsToSend);
    } else {
      window.utag.link(trackingParamsToSend);
    }
  } else {
    // This is necessary because utag.js script is loaded asynchronously
    setTimeout(() => sendTrackingParams(trackingParamsToSend, isView), 1000);
  }
}
export const trackError = (errorType, currentTabTraking) => {
  trackInteraction({
    eventType: 'interactions',
    interaction: `${currentTabTraking}:error:${errorType}`,
  });
};

export const trackSuccessCruiseReservation = (trackingParams) => {
  trackInteraction({
    eventType: 'interactions',
    interaction: 'airlookup:success',
    ...trackingParams,
  });
};

export const trackDepartureResultsView = () => {
  const searchResults = searchResultsVar();
  const browseParams = browseParamsVar();
  const searchCriteria =
    browseParams && browseParams.searchCriteria
      ? {
          departureDate: `${browseParams.searchCriteria.selectedYear}-${browseParams.searchCriteria.month}-${browseParams.searchCriteria.day}`,
          browseFlightsShipCode: browseParams.searchCriteria.shipCode,
          fsGuests: browseParams.searchCriteria.numberOfGuests,
          fsDepartureAirportCode: browseParams.searchCriteria.departureAirportCode,
          // TODO: Once we start supporting different types, we should obtain this dynamically
          fsType: 'roundtrip',
        }
      : {};
  trackView({
    eventType: 'interactions',
    interaction: `${siteSection}:search`,
    pageName: `${siteSection}:departure`,
    pageType: `${siteSection}:departureFlight`,
    siteSection: 'browseFlights',
    ...searchCriteria,
    fsDepartureResults:
      searchResults && searchResults.matchingFlights ? searchResults.matchingFlights.length : 0,
  });
};

export const trackReturnResultsView = () => {
  const searchResults = searchResultsVar();
  const selectedDeparture = selectedDepartureVar();
  const departureFlight = selectedDeparture && selectedDeparture.flight;
  const browseParams = browseParamsVar();
  const searchCriteria =
    browseParams && browseParams.searchCriteria
      ? {
          departureDate: `${browseParams.searchCriteria.selectedYear}-${browseParams.searchCriteria.month}-${browseParams.searchCriteria.day}`,
          browseFlightsShipCode: browseParams.searchCriteria.shipCode,
        }
      : {};
  trackView({
    pageName: `${siteSection}:return`,
    pageType: `${siteSection}:returnFlight`,
    siteSection: 'browseFlights',
    ...searchCriteria,
    fsReturnResults:
      searchResults && searchResults.matchingFlights ? searchResults.matchingFlights.length : 0,
    flightDepartureDate: (departureFlight && departureFlight.departDate) || '',
    departureAirlineCode: getMarketingAirlineCodesFromFlight(departureFlight),
  });
};

export const trackSummaryView = () => {
  const browseParams = browseParamsVar();
  const searchCriteria =
    browseParams && browseParams.searchCriteria
      ? {
          departureDate: `${browseParams.searchCriteria.selectedYear}-${browseParams.searchCriteria.month}-${browseParams.searchCriteria.day}`,
          browseFlightsShipCode: browseParams.searchCriteria.shipCode,
        }
      : {};
  trackView({
    eventType: 'interactions',
    interaction: `${siteSection}:summary`,
    pageName: `${siteSection}:selected`,
    pageType: `${siteSection}:selectedFlight`,
    siteSection: 'browseFlights',
    ...buildCommonProductObject(),
    ...searchCriteria,
  });
};

export const trackSuccesGiftCard = (amount) => {
  trackInteraction({
    eventType: 'interactions',
    interaction: `air:giftcardvalidation:success`,
    giftCardAmount: amount,
  });
};
export const trackremoveGiftCard = () => {
  trackInteraction({
    eventType: 'interactions',
    interaction: `air:giftcard:removed`,
  });
};

export const trackErrorGiftCard = (errorType, currentTabTraking) => {
  trackInteraction({
    eventType: 'interactions',
    interaction: `${currentTabTraking}:${errorType}`,
  });
};

export function trackSuccesGiftCardPayment(trackInformation) {
  const creditCardType =
    trackInformation && trackInformation.creditCardType && trackInformation.creditCardType;

  const CARD_TYPES = {
    AX: 'mericanexpress',
    DC: 'dinersclub',
    DS: 'discover',
    JC: 'jcb',
    MC: 'mastercard',
    VA: 'visa',
  };

  const cardTypeName = CARD_TYPES[creditCardType];

  trackView({
    eventType: 'interactions',
    interaction: 'air:giftcard:applied',
    totalGiftCardAmntApplied: trackInformation.gCPaymentAmount,
    paymentMethod: creditCardType ? `${cardTypeName}:giftcard` : 'giftcard',
  });
}

export const trackCancellationView = ({
  country,
  language,
  loginStatus,
  currency,
  sailDate,
  ship,
  bookingID,
  flightReservationNumber,
  flightprodCategory,
  flightprodSku,
  flightprodQuantity,
  flightProdCost,
}) => {
  trackView({
    pageName: `airbooking:cancelFlight`,
    siteSection: 'manageFlight',
    pageType: 'manageFlight',
    country,
    language,
    loginStatus,
    currency,
    sailDate,
    ship,
    bookingID,
    flightReservationNumber,
    flightprodCategory,
    flightprodSku,
    flightprodQuantity,
    flightProdCost,
  });
};
